import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../utils/GoogleMapKey";
import { Spinner } from "react-bootstrap";

const mapContainerStyle = {
  width: "100%",
  height: "500px",
};



const PortalMap = ({ userLocation, driverLocation, zoom }) => {
  const [show, setShow] = useState(false);
  const [currentZoom, setCurrentZoom] = useState(zoom);
  const [mapInstance, setMapInstance] = useState(null);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  
  const parsedUserLocation = userLocation
    ? {
        lat: parseFloat(userLocation.lat),
        lng: parseFloat(userLocation.lng),
      }
    : { lat: 0, lng: 0 };

  const [mapCenter, setMapCenter] = useState(parsedUserLocation);

  useEffect(() => {
    let timer = setTimeout(() => setShow(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (userLocation) {
      setMapCenter(userLocation);
    }
  }, [userLocation]);

  const handleZoomChanged = () => {
    if (mapInstance) {
      const newZoom = mapInstance.getZoom();
      setCurrentZoom(newZoom);
    }
  };

  const handleOnLoad = (map) => {
    setMapInstance(map);
    setIsMapLoaded(true);
  };

  if (!parsedUserLocation || isNaN(parsedUserLocation.lat) || isNaN(parsedUserLocation.lng)) {
    console.error("Invalid userLocation:", parsedUserLocation);
    return <div className="error">Error: Invalid user location</div>;
  }

  if (driverLocation && (isNaN(driverLocation.lat) || isNaN(driverLocation.lng))) {
    console.error("Invalid driverLocation:", driverLocation);
    return <div className="error">Error: Invalid driver location</div>;
  }

  if (!show)
    return (
      <div className="map-picker-loading">
        <div className="loading-cont">
          <Spinner animation="border" role="status" />
          <p>Loading Map...</p>
        </div>
      </div>
    );

    let userIcon, driverIcon;
  if (isMapLoaded && window.google) {
    userIcon = {
      path:
      "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
      fillColor: "#3a5c81", // User color
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 2, // Adjust the size of the marker
      anchor: new window.google.maps.Point(12, 24), // Align the bottom tip of the marker with the coordinates
      labelOrigin: new window.google.maps.Point(12, 9), // Position label in the center of the pin
    };

    driverIcon = {
      path:
      "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
      fillColor: "#d2085b", // Driver color
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 2, // Adjust the size of the marker
      anchor: new window.google.maps.Point(12, 24), // Align the bottom tip of the marker with the coordinates
      labelOrigin: new window.google.maps.Point(12, 9), // Position label in the center of the pin
    };
  }
  

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={currentZoom}
        center={mapCenter}
        onZoomChanged={handleZoomChanged}
        onLoad={handleOnLoad}
      >
        {/* Marker for userLocation */}
        {parsedUserLocation && (
          <Marker
            position={{ lat: parsedUserLocation.lat, lng: parsedUserLocation.lng }}
            icon={userIcon}
            label={{
              text: "U",
              color: "white",
              fontWeight: "Poppins Bold",
              fontSize: "18px",
            }}
          />
        )}
        {/* Marker for driverLocation */}
        {driverLocation && (
        <Marker
            position={{ lat: driverLocation.lat, lng: driverLocation.lng }}
            icon={driverIcon}
            label={{
              text: "D",
              color: "white",
              fontWeight: "Poppins Bold",
              fontSize: "18px",
            }}
          />
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default PortalMap;
